"use strict";

var Proj = (function(proj) {

	proj.interfaceName = '';

	function __current_interface_name() {
		return ($('body').data("interfaceName") ? $('body').data("interfaceName") : '');
	}

	var AJAX_URI = '/json/';

	var SESS_ID = '';

	if (window.location.toString().match(/SESS_ID=(\d+)/)) {
		SESS_ID = RegExp.$1;
	}

	/*****************(.Y.)******************/
    proj.getJSON = function(data, handler) {
		if (SESS_ID)
			data['SESS_ID'] = SESS_ID;
		$.post(AJAX_URI, data, handler, 'json');
	}	

	proj.fancybox = function() {
		var _fancy = $(".fancybox") || {};

		_fancy.fancybox({
            helpers : {
                overlay : {
                    locked: false
                },
                title : {
                    type : 'outside'
                }
            }
		});
		
	}

	/****************(.Y.)********************/
    
    proj.homeClientsSlider = function(selector) {

    	var $selector = $(selector) || {},
    	      $slides = $selector.find('a') || {};
        
        if($slides.length > 3) {
	    	$selector.find(".list").slick({
	    		infinite       : true,
	            dots           : false,
	            slidesToShow   : 3,
	            slidesToScroll : 1,
	            autoplay       : true,
	            prevArrow      : $selector.find(".prev"),
	            nextArrow      : $selector.find(".next")
	    	});
        }
    }


    proj.homeSwitchBlock = function(selector) {
    	var $selector = $(selector) || {};

    	$selector.each(function(){
            
            var _self     = $(this),
                _switcher = _self.find(".switch__item");

            _switcher.on("click", function(e){                
                var _this = $(this),
                    _obj  = _this.data("object"),
                    _p    = $selector.find('.descr__item[data-object="'+_obj+'"]');
                    

                if(!_p.hasClass('active')) {
                    $('.bg__item').removeClass('active');
                    $('.descr__item').removeClass('active');
                    _switcher.removeClass('active');
                    _p.addClass('active');
                    $('.bg__item[data-object="'+_obj+'"]').addClass('active');
                    _this.addClass('active');
                }

            });           

    	});

    }

    proj.prodDoubleSlider = function(bigSlider, smallSlider) {
        
        var $big_slider = $(bigSlider) || {};
        var $small_slider = $(smallSlider) || {};

        $big_slider.find(".list").slick({
	    	infinite       : true,
	        dots           : false,
	        slidesToShow   : 1,
	        slidesToScroll : 1,
	        autoplay       : true,
	        arrows         : false,
            speed          : 500,
	        fade           : true,
            cssEase        : 'linear',
            asNavFor       : $(smallSlider).find(".list")
	        
	    });

	    $small_slider.find(".list").slick({
	    	infinite       : true,
	        dots           : false,
	        slidesToShow   : 2,
	        slidesToScroll : 1,
	        autoplay       : true,
	        arrows         : false,
	        asNavFor       : $(bigSlider).find(".list"),
	        focusOnSelect  : true,
	        slide          : 'div'
	        
	    });
	    
    }

    proj.prodTabs = function(selector) {

    	var $selector = $(selector) || {};

    	$selector.each(function(){
            
            var _self  = $(this),
                _title = _self.find('.tabs__title .item');

            _title.on("click", function(){

            	var _this = $(this),
            	    _id   = _this.data("id"),
            	    _tabs = _this.parents('.tabs').find(".tabs__content");

            	if(!_this.hasClass('enable')) {
                   
                   _this.parent().find('.enable').removeClass('enable').addClass('disable');
                   _this.removeClass('disable').addClass('enable');
                   _tabs.find('.enable').removeClass('enable').addClass('disable');
                   _tabs.find('[data-id="'+_id+'"]').removeClass('disable').addClass('enable');

                   /*var _height = 0;
                   _tabs.find('[data-id="'+_id+'"]').children().each(function(){
                       _height = _height + $(this).outerHeight();
                   });

                   _tabs.find('[data-id="'+_id+'"]').css({height: _height+"px"});*/

                   if(_tabs.find('[data-id="'+_id+'"]').find(".work__gallery").length) {
                       _tabs.find('[data-id="'+_id+'"]').find(".work__gallery").find(".list").slick('setPosition');
                   }


            	}

            });

    	});

    }


    proj.prodFloatMenu = function() {
    	var $menu     = $('.side-menu') || {},
    	    $p_column = $('.prod-list-column') || {};

        $menu.each(function(){

        	var _this   = $(this),
        	    _height = _this.outerHeight(),
        	    _offset = _this.offset().top,
        	    _ph     = $p_column.outerHeight(),
        	    _wnd    = $(window);
            
            if(_height < _ph) {
               
                _wnd.on("scroll", function(){

                    var _scroll = $(this).scrollTop();

                    if( (_scroll > _offset) && (_scroll < (_offset + _ph - $(this).height()) ) ) {
                    	_this.stop(true, false).animate({
                    		marginTop: _scroll - _offset + "px"
                    	}, 500);
                    }

                });

            }


        });

    }


    proj.dropDownFilterSelect = function(select, form) {
    	var $select = $(select) || {},
    	    $form   = $(form) || {};

    	$select.each(function(){
            
            var _self    = $(this),
                _pointer = _self.find(".current"),
                _list    = _self.find(".list");

            _pointer.on("click", function(){
                
                if(!_self.hasClass("open")) {
                    _self.addClass("open");

                    _list.show().stop(true, false).animate({opacity: 1, top: "40px"}, 350);

                    $(document).on("click.dropDown", function(e){
                       if( !$(e.target).closest(_self).length ) {
                            _list.stop(true, false).animate({opacity: 0, top: "60px"}, 350, function(){
		                        _self.removeClass("open");
		                        _list.hide();
		                	});       

		                	$(document).off("click.dropDown");
                       }
                    });

                } else {
                	
                	_list.stop(true, false).animate({opacity: 0, top: "60px"}, 350, function(){
                        _self.removeClass("open");
                        _list.hide();
                	});
                }

            });


            _list.each(function(){
                
                var _li = $(this).find("li");

                _li.on("click", function(){
                    
                    var _this    = $(this),
                        _type    = _this.data("type"),
                        _id      = _this.data("id"),
                        _current = _this.parents(".drop-down-select").find(".current");
                    
                    _this.parent().find(".active").removeClass("active");
                    _current.text(_this.text());
                    _this.addClass("active");

                    $form.find('input[name="'+_type+'"]').attr("value", _id);

                    _this.parent().stop(true, false).animate({opacity: 0, top: "60px"}, 350, function(){
                        _this.parents(".drop-down-select").removeClass("open");
                        _this.parent().hide();
                        $form.trigger("submit");
                	});



                });

            });

    	});

    }

    proj.workDoubleSlider = function(bigSlider, smallSlider) {
        
        var $big_slider = $(bigSlider) || {};
        var $small_slider = $(smallSlider) || {};

        $big_slider.each(function(){
           $(this).find(".list").slick({
		    	infinite       : true,
		        dots           : false,
		        slidesToShow   : 1,
		        slidesToScroll : 1,
		        autoplay       : true,
		        arrows         : false,
	            speed          : 500,
		        fade           : true,
	            cssEase        : 'linear',
	            asNavFor       : $(this).parent().find(smallSlider).find(".list")
		        
		    });
        });

        
        $small_slider.each(function(){
            $(this).find(".list").slick({
		    	infinite       : true,
		        dots           : false,
		        slidesToShow   : 6,
		        slidesToScroll : 1,
		        autoplay       : true,
		        arrows         : false,
		        asNavFor       : $(this).parent().find(bigSlider).find(".list"),
		        focusOnSelect  : true,
		        slide          : 'div'
		        
		    });
        });        

	    
	    
    }

    proj.pageGallerySlider = function(selector) {
        var $gallery = $(selector) || {};

        $gallery.each(function(){
            var _this  = $(this),
                _slide = _this.find('li'),
                _left  = _this.parent().find(".left"),
                _right = _this.parent().find(".right");

            _left.hide();
            _right.hide();
            
            if(_slide.length > 5) {
                _left.show();
                _right.show();

                _this.slick({
                    infinite       : true,
                    dots           : false,
                    slidesToShow   : 5,
                    slidesToScroll : 1,
                    autoplay       : true,
                    prevArrow      : _left,
                    nextArrow      : _right
                });

            } 
            
        });

    }

    proj.processFormField = function(form) {
        var $form = $(form) || {};

        $form.each(function(){
            var _self   = $(this),
                _file   = _self.find(".file") || {},
                _select = _self.find(".enum") || {};

            _file.each(function(){
                var _this  = $(this),
                    _label = _this.find(".label"),
                    _input = _this.find("input");

                _label.hide();
                _input.attr("id",_input.attr("name")+'-'+_this.index());
                var file_label = $(document.createElement("span")).addClass("file-label").text(_label.text()).appendTo(_this);
                var file_btn = $(document.createElement("label")).addClass("file-btn").attr("for",_input.attr("id")).text("обзор").appendTo(_this);
                
                _input.on("change", function(e){
                    //e.preventDefault();
                    var _name = e.target.value.split( '\\' ).pop();
                    file_label.text(_name);
                    
                });

            });

            _select.each(function(){
                var _this = $(this),
                    _list = _this.find("select"),
                    _opt  = _list.find("option");

                var _values = [];
                
                var i = 0;
                var current_text = '';
                for(i = 0; i < _opt.length; i++) {
                    var _obj = {};
                    _obj.title    = _opt[i].innerHTML;
                    _obj.index    = _opt[i].index;
                    _obj.selected = _opt[i].selected;
                    _obj.class    = (_opt[i].selected) ? 'active' : 'normal';
                    if(_opt[i].selected) {
                        current_text = _opt[i].innerHTML
                    }
                   _values[i] = _obj;
                }
                
                if(!current_text) {
                    current_text = _values[0].title;
                }

                var _widget = $(document.createElement('div')).addClass('form-drop-down').appendTo(_this);
                var _current = $(document.createElement('span')).addClass('current').text(current_text).appendTo(_widget);
                var _ul = $(document.createElement('ul')).addClass('list').appendTo(_widget);

                for(i = 0; i < _values.length; i++) {
                   var _li = $(document.createElement('li'))
                              .addClass('list__item')
                              .addClass(_values[i].class)
                              .attr("data-index",_values[i].index)
                              .text(_values[i].title)
                              .appendTo(_ul);                    
                }

                _list.hide();

                _widget.each(function(){
            
                    var _self    = $(this),
                        _pointer = _self.find(".current"),
                        _ul    = _self.find(".list");

                    _pointer.on("click", function(){
                        
                        if(!_self.hasClass("open")) {
                            _self.addClass("open");

                            _ul.show().stop(true, false).animate({opacity: 1, top: "50px"}, 350);

                            $(document).on("click.dropDown", function(e){
                               if( !$(e.target).closest(_self).length ) {
                                    _ul.stop(true, false).animate({opacity: 0, top: "70px"}, 350, function(){
                                        _self.removeClass("open");
                                        _ul.hide();
                                    });       

                                    $(document).off("click.dropDown");
                               }
                            });

                        } else {
                            
                            _ul.stop(true, false).animate({opacity: 0, top: "70px"}, 350, function(){
                                _self.removeClass("open");
                                _ul.hide();
                            });
                        }

                    });


                    _ul.each(function(){
                        
                        var _li = $(this).find("li");

                        _li.on("click", function(){
                            
                            var _this    = $(this),
                                _index   = _this.data("index"),
                                _current = _this.parents(".form-drop-down").find(".current");
                            
                            _this.parent().find(".active").removeClass("active");
                            _current.text(_this.text());
                            _this.addClass("active");

                            _list.find("option").eq(_index).prop("selected", true);

                            _this.parent().stop(true, false).animate({opacity: 0, top: "70px"}, 350, function(){
                                _this.parents(".form-drop-down").removeClass("open");
                                _this.parent().hide();
                            });



                        });

                    });

                });

            });


        });

    }

    proj.ScrollTo = function(selector) {
        var $selector = $(selector) || {};

        $selector.click(function() {
            if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
              var target = $(this.hash);
              target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
              if (target.length) {
                $('html,body').animate({
                  scrollTop: target.offset().top
                }, 1000);
                return false;
              }
            }
        });

    }


	proj.init = function() {

		proj.interfaceName = __current_interface_name();

		console.log("Init project done.");
	};

	return proj;

})(Proj || {});